import merge from 'lodash-es/merge';
import { getDefaultTranslations } from '../services/language/languages';

export default function (state, action) {
  const payload = action.payload;

  switch (action.type) {
    case 'setActions':
      return actionsReducer(state, payload);
    case 'setBadges':
      return Object.assign({}, state, { badges: payload });
    case 'setCanUseAPI':
      return Object.assign({}, state, { canUseAPI: payload });
    case 'setChannels':
      return channelsReducer(state, payload);
    case 'openChannels':
      return Object.assign({}, state, { channelsOpen: payload });
    case 'setColor':
      return Object.assign({}, state, { color: payload });
    case 'setOffsetX':
      return Object.assign({}, state, { offsetX: payload });
    case 'setOffsetY':
      return Object.assign({}, state, { offsetY: payload });
    case 'setPosition':
      return Object.assign({}, state, { position: payload });
    case 'setLogo':
      return Object.assign({}, state, { logo: payload });
    case 'setMediaMobileWidth':
      return Object.assign({}, state, { mediaMobileWidth: payload });
    case 'setFlashcard':
      return Object.assign({}, state, { flashcard: payload });
    case 'setHideAllBtn':
      return Object.assign({}, state, { hideAllBtn: payload });
    case 'setIsFrameOpened':
      return Object.assign({}, state, { isFrameOpened: payload });
    case 'setIsLoaderHidden':
      return Object.assign({}, state, { isLoaderHidden: payload });
    case 'setLanguage':
      return setLanguageReducer(state, payload);
    case 'setGeneralData':
      return generalDataReducer(state, payload);
    case 'setStyleTemplate':
      return Object.assign({}, state, { styleTemplate: payload });
    case 'setTitle':
      return Object.assign({}, state, { title: payload });
    case 'setTranslations':
      return translationsReducer(state, payload);
    case 'setWidgetVersion':
      return Object.assign({}, state, { widgetVersion: payload });
    case 'setItemsOrder':
      return itemsOrderReducer(state, payload);
    default:
      return state;
  }
}

/** ************** REDUCERS *********************** */

//todo implement in widget
function generalDataReducer(state, payload) {
}

/**
 *
 * @param {StoreState} state
 * @param {Object} order - ex: {chat:10, Mail:5}
 *
 * @returns {StoreState} - with reordered items
 */
function itemsOrderReducer(state, order) {
  return itemsReloader(Object.assign({}, state, { order: order }));
}

function actionsReducer(state, actions) {
  var items = state.items;

  items = items.filter((ele) => ele.isChannel).concat(createMenuActions(actions, state));

  return Object.assign({}, state, { items: items })
  // return { ...state, items };
}

function channelsReducer(state, channels) {
  var items = state.items;

  items = items.filter((ele) => !ele.isChannel)
    .concat(createMenuChannels(channels, state));

  // action mock
  // items.push(createMenuActions([{
  //   id: "2", type: 1, data: {
  //     href: "https://www.morele.net/index/faq_wybor/", target: "_self", desc: { en: "Contact us", pl: "Napisz do nas" }
  //   }
  // }], state.language)[0]);

  return Object.assign({}, state, { items: items })
  // return { ...state, items };
}

function translationsReducer(state, payload) {
  const translations = merge(state.translations, payload);

  const messages = merge(state.messages, translations[state.language]);
  // const items = state.items.map(function (ele) {
  //   ele.tooltip = (ele.desc && ele.desc[state.language]) || translations.LOADER_FAB_MENU[ele.name.toUpperCase()];
  //   return ele;
  // });

  const reloadedState = itemsReloader(Object.assign({}, state, { messages: messages, translations: translations }));

  return Object.assign({}, reloadedState, { title: messages.LOADER_TITLE })
}

function setLanguageReducer(state, payload) {
  const messages = merge(getDefaultTranslations(payload), state.translations[payload]);

  const reloadedState = itemsReloader(Object.assign({}, state, { language: payload, messages: messages }));

  return Object.assign({}, reloadedState, { title: messages.LOADER_TITLE });
}


/** ************** HELPERS *********************** */
function createMenuActions(actions, state) {
  var language = state.language,
    order = getOrder(state);
//todo if translation for given action is set - maybe use it instead desc from backend?

  actions = Array.isArray(actions) ? actions : [];

  return actions.map(function (action) {
    const data = action.data;

    return {
      name: data.name || 'action_mail',
      href: data.href,
      target: data.target,
      tooltip: data.desc[language],
      isVisible: true,
      order: order[data.name] || data.order,
      type: action.type,
      isChannel: false
    }
  });
}

function createMenuChannels(channels, state) {
  var language = merge(state.messages, state.translations[state.language]).LOADER_FAB_MENU,
    order = getOrder(state);

  channels = channels || {};

  return Object.keys(channels).map(function (channel) {
    return {
      name: channel,
      tooltip: language[channel.toUpperCase()],
      isVisible: channels[channel],
      order: order[channel] || 0,
      isChannel: true
    }
  });
}

function getOrder(state) {
  return Object.assign(state.defaultOrder, state.order);
}

/**
 *
 * @param {StoreState} state
 *
 * @returns {StoreState} - with reordered items
 */
function itemsReloader(state) {
  const translations = merge(state.messages, state.translations[state.language]).LOADER_FAB_MENU;
  const order = getOrder(state);

  const items = state.items.map(function (ele) {
    ele.order = order[ele.name] || ele.order;
    ele.tooltip = translations[ele.name.toUpperCase()] || ele.tooltip;
    return ele;
  });

  return Object.assign({}, state, { items: items })
}
